import axiosInstance from ".";

export const loginAPI = async ({ body }) => {
    const response = await axiosInstance.post(`/supplier/auth/login`, body)
    return response;
}

export const RegisterAPI = async ({ body }) => {
    const response = await axiosInstance.post(`/supplier/auth/register`, body)
    return response;
}
export const ResetPasswordAPI = async ({ body }) => {
    const response = await axiosInstance.post(`/supplier/auth/reset_password`, body)
    return response;
}
export const ForgotPasswordAPI = async ({ body }) => {
    const response = await axiosInstance.post(`/supplier/auth/forgot_password`, body)
    return response;
}

